/**
 * @Author: v_jppjpeng
 * @Date: 2024-08-01 19:21:21
 * @Explain: 防打扰策略
 */
import http from '../http';
// type
import type { HttpResponse } from '../data.d';
import type { collingType, strategyPushType } from './data.d';

const MODEL = '/strategy';

export default {
  // 保存
  onSave(data: Record<any, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/save_strategy`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 详情
  getDetails(data: Record<any, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/get_strategy`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // PUSH 保存
  onSavePush(data: Record<any, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/save_push_strategy`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // PUSH 详情
  getDetailsPush(
    data: Record<any, any>,
  ): Promise<HttpResponse<strategyPushType & collingType>> {
    return http.post(`${MODEL}/get_push_strategy`, data, {
      params: { switchReqToUnderline: true },
    });
  },
};
